import { LogoIcon } from "@/components/icons/logo-icon";
import MyProfileMenu from "@/components/toolbar/header-toolbar/my-profile-menu";
import { cn } from "@/utils/cn";
import {
  IonContent,
  IonHeader,
  IonIcon,
  IonModal,
  IonPage,
  IonToolbar,
} from "@ionic/react";
import { exitOutline } from "ionicons/icons";

interface SettingContainerProps {
  children: React.ReactNode;
  className?: string;
}

export const SettingContainer = ({
  children,
  className,
}: SettingContainerProps) => {
  return (
    <>
      <IonPage color="background-gray">
        <IonHeader>
          <IonToolbar color="background-gray">
            <div className="flex items-center justify-between max-w-[420px] px-4 py-4 mx-auto">
              <LogoIcon className="max-w-[120px]" />

              <button
                id="open-profile-menu"
                className="rounded-full border border-gray-100 flex items-center justify-center p-2"
              >
                <IonIcon icon={exitOutline} />
              </button>
            </div>
          </IonToolbar>
        </IonHeader>
        <IonContent fullscreen color="background-gray">
          <div
            className={cn(
              "flex flex-col items-start gap-4 justify-start self-center p-4",
              "w-full max-w-[420px] mx-auto h-full",
              className,
            )}
          >
            {children}
          </div>
        </IonContent>
      </IonPage>
      <IonModal
        trigger="open-profile-menu"
        initialBreakpoint={0.25}
        breakpoints={[0, 0.25, 0.5, 0.75]}
      >
        <MyProfileMenu />
      </IonModal>
    </>
  );
};
